module.exports = __webpack_public_path__ + "img/nav-futi.b547cfd1.png";